import {ReactNode} from 'react';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import JobSearchBar from '@jobseeker/lotus/components/JobSearchBar/V1';
import {
  Box,
  Chip as MuiChip,
  Grid,
  IconButton,
  Link,
  styled,
  Typography,
} from '@mui/material';
import MediaCard from '@jobseeker/lotus/components/MediaCard';
import ArticleCard from '@jobseeker/lotus/components/ArticleCard';
// import {Button} from '@jobseeker/lotus/elements';
import {RiCloseCircleLine} from 'react-icons/ri';
import Slide from '@mui/material/Slide';
import {TransitionProps} from '@mui/material/transitions';
import {forwardRef} from 'react';
import {VersionVariants} from '@jobseeker/lotus/enums';
import Image from '@jobseeker/lotus/components/Image';

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const imglinklist = [
  'https://d3qr48lsanmyop.cloudfront.net/1670999954174.jpeg',
  'https://d3qr48lsanmyop.cloudfront.net/1655890992417.jpeg',
  'https://d3qr48lsanmyop.cloudfront.net/1671000224245.jpeg',
  'https://d3qr48lsanmyop.cloudfront.net/1660629888878.jpeg',
  'https://d3qr48lsanmyop.cloudfront.net/1664279767458.jpeg',
];
const ImageCard = styled(Image)(props => ({
  width: '100px',
  height: '100px',
  borderRadius: '5px',
  border: '1px solid #ddd',
}));
const Chip = styled(MuiChip)(props => ({
  transition: 'all ease 0.2s',
  ':hover': {
    '.MuiChip-label': {
      textDecoration: 'underline',
    },
    // backgroundColor: props.theme.palette.primary.light,
    color: props.theme.palette.primary.dark,
    borderColor: props.theme.palette.primary.light,
  },
  cursor: 'pointer',
}));

export interface DialogBoxProps extends DialogProps {
  open: boolean;
  BottomAction: ReactNode;
  title?: string;
  closeDialog: any;
}
export default function DialogBox({
  BottomAction,
  title,
  ...props
}: DialogBoxProps) {
  const closeDialog = () => {
    props.closeDialog();
  };
  return (
    <div>
      <Dialog
        fullScreen
        {...props}
        scroll={'paper'}
        TransitionComponent={Transition}
      >
        <DialogContent dividers={true}>
          <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
            <IconButton onClick={closeDialog} color="secondary">
              <Typography variant="h4" component="span" sx={{lineHeight: 0}}>
                <RiCloseCircleLine />
              </Typography>
            </IconButton>
          </Box>
          <JobSearchBar
            variant={VersionVariants.VERSION_ONE}
            showSortBy={false}
            showSearchInput={false}
          />
          <Grid
            container
            sx={{mt: 0}}
            columnSpacing={{xxs: 0, md: 2, lg: 3, xl: 4}}
            rowSpacing={6}
            direction={'row-reverse'}
          >
            <Grid item xxs={12} md={6}>
              <Typography variant="h6">Featured Employer</Typography>
              <ArticleCard
                title="Franklin Templeton"
                description={`
Since 1947, our firm has been dedicated to delivering exceptional asset management for institutional, retail, and high-net-worth clients. Find out what gives us our unique investment perspective.  With more than 12,000 employees in 34 countries around the world, we are uniquely positioned to look beyond the largest or most visible securities in each market to spot smart global investments that meet our rigorous investment criteria. Our firsthand understanding of local culture, companies and economies sets us apart as a truly global partner`}
                imgUrl="https://d3qr48lsanmyop.cloudfront.net/1671000826623.jpeg"
                logoUrl="https://d3qr48lsanmyop.cloudfront.net/1671000913068.jpeg"
                actionLabel="See inside the office of Franklin Templeton"
              />
            </Grid>
            <Grid item xxs={12} md={6}>
              <Typography variant="h6">Recent Searches</Typography>
              <Box sx={{display: 'flex', gap: '10px', flexWrap: 'wrap'}}>
                {[...new Array(6)].map((p, i) => (
                  <Chip label={`Search Result ${i + 1}`} variant="outlined" />
                ))}
              </Box>
              <Box sx={{mt: 4}}>
                <Typography variant="h6">Top Employers</Typography>
                <Box sx={{display: 'flex', gap: '7px', flexWrap: 'wrap'}}>
                  {imglinklist.map((imgsrc, i) => (
                    <>
                      <a href="#">
                        <ImageCard
                          alt={'company name'}
                          src={imgsrc}
                          loading="lazy"
                        />
                      </a>
                    </>
                  ))}
                </Box>
              </Box>
              <Box sx={{mt: 4}}>
                <Typography variant="h6">Trending Courses</Typography>
                <Grid container spacing={2}>
                  {[...new Array(3)].map((imgsrc, i) => (
                    <>
                      <Grid item xxs={6} sm={4}>
                        <Link
                          href="#"
                          sx={{
                            textDecoration: 'none',
                            ':hover': {textDecoration: 'underline'},
                          }}
                        >
                          <MediaCard
                            subtitle={
                              'MIT AIML | AI & ML: Leading Business Growth - MIT Professional Education'
                            }
                            mediaUrl={
                              'https://d3qr48lsanmyop.cloudfront.net/1675851348949.jpeg'
                            }
                            cover={false}
                            variant={VersionVariants.VERSION_ONE}
                          />
                        </Link>
                      </Grid>
                    </>
                  ))}
                </Grid>
              </Box>
            </Grid>
          </Grid>
          {/* {props.children} */}
        </DialogContent>
        {/* {BottomAction && <DialogActions>{BottomAction}</DialogActions>} */}
      </Dialog>
    </div>
  );
}
